import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Flex,
  VStack,
  Text,
  Icon,
  useColorModeValue,
  Spacer,
  Avatar,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  IconButton,
  HStack,
  Center,
} from "@chakra-ui/react";
import {
  MdDashboard,
  MdSearch,
  MdTask,
  MdPeople,
  MdVerifiedUser,
  MdLogout,
  MdSettings,
} from "react-icons/md";
import logo from "../assets/logo/altroverse.png";

const SidebarItem = ({ icon, children, isActive = false, onClick }) => {
  const bg = isActive ? "#FF9900" : "transparent";
  const color = isActive ? "black" : "white";

  return (
    <Flex
      align="center"
      p="3"
      mx="2"
      borderRadius="lg"
      role="group"
      cursor="pointer"
      bg={bg}
      color={color}
      _hover={{ bg: isActive ? "#FF9900" : "gray.700", color: "white" }}
      onClick={onClick}
      transition="all 0.2s"
    >
      <Icon mr="3" fontSize="16" as={icon} />
      <Text fontSize="sm" fontWeight="medium">
        {children}
      </Text>
    </Flex>
  );
};

const AdminLayout = ({ children, activeTab = "dashboard" }) => {
  const navigate = useNavigate();

  const menuItems = [
    {
      id: "dashboard",
      icon: MdDashboard,
      label: "Dashboard",
      path: "/dashboard",
    },
    { id: "batches", icon: MdSearch, label: "Batches", path: "/batches" },
    { id: "tasks", icon: MdTask, label: "Tasks", path: "/tasks" },
    { id: "users", icon: MdPeople, label: "Users", path: "/users" },
    // { id: "verifications", icon: MdVerifiedUser, label: "Verifications" },
  ];

  const handleNavigation = (path) => {
    navigate(path);
  };

  const username = localStorage.getItem("username");
  const role = localStorage.getItem("user_role");

  const handleLogout = () => {
    localStorage.clear();
    navigate("/");
  };

  return (
    <Box minH="100vh" bg="#121212">
      {/** Header */}
      <div className="w-full h-16 bg-black flex items-center px-10 justify-between">
        <div>
          <img src={logo} className="w-full h-6" alt="ALTROVERSE" />
        </div>
        {/* User Menu */}
        <Box p="4" borderTop="1px" borderTopColor="#1C1C1C">
          <Menu>
            <MenuButton
              as={Flex}
              align="center"
              p="2"
              borderRadius="lg"
              cursor="pointer"
              _hover={{ bg: "gray.700" }}
              w="full"
              justify="center"
              items="center"
              bg="#FF9900"
            >
              {/* <Avatar size="sm" mr="2" bg="#FF9900" /> */}
              <Text fontSize="lg" color="black">
                {username}
              </Text>
            </MenuButton>
            <MenuList bg="gray.800" borderColor="gray.700">
              <MenuItem
                // icon={<MdSettings />}
                bg="gray.800"
                _hover={{ bg: "gray.700" }}
              >
                {role}
              </MenuItem>
              <MenuItem
                icon={<MdLogout />}
                bg="gray.800"
                _hover={{ bg: "gray.700" }}
                onClick={handleLogout}
              >
                Logout
              </MenuItem>
            </MenuList>
          </Menu>
        </Box>
      </div>
      <Flex>
        {/* Sidebar */}
        <Box
          w="240px"
          bg="#121212"
          borderRight="1px"
          borderRightColor="#3A3A3A"
          minH="100vh"
        >
          <VStack align="stretch" spacing={0}>
            {/* Navigation */}
            <VStack align="stretch" spacing={1} p="4">
              {menuItems.map((item) => (
                <SidebarItem
                  key={item.id}
                  icon={item.icon}
                  isActive={activeTab === item.id}
                  onClick={() => handleNavigation(item.path)}
                >
                  {item.label}
                </SidebarItem>
              ))}
            </VStack>

            <Spacer />
          </VStack>
        </Box>

        {/* Main Content */}
        <Box flex="1" p="6" bg="#1C1C1C">
          {children}
        </Box>
      </Flex>
    </Box>
  );
};

export default AdminLayout;
